import React from 'react';
import TextField from '../TextField/TextField';
import { phoneMask } from '../../../../utils/phoneMask';
import { numPattern } from '../../../../constants/patterns';
import styles from './PhoneField.module.scss';

const PhoneField = (props) => {
  const { inputProps, ...otherProps } = props;

  const handlePhonePaste = (e) => {
    e.persist();

    const input = e.target;
    const pasted = e.clipboardData;

    if (pasted) {
      const pastedText = pasted.getData('Text');

      if (numPattern.test(pastedText)) {
        if (input.value.length > 0) {
          input.value = input.value.replace(numPattern, '');
        } else {
          let formattedText = pastedText.replace(numPattern, '');

          if (formattedText.length === 11) {
            formattedText = formattedText.substring(1);
          }

          input.value = formattedText;
        }

        return;
      }
    }
  };

  const handleChange = (e) => {
    e.persist();

    const input = e.target;
    const selectionStart = input.selectionStart;

    if (input.value.length !== selectionStart) {
      const data = e.nativeEvent.data;

      if (data && numPattern.test(data)) {
        input.value = input.value.replace(data, '');
        input.selectionStart = selectionStart - 1;
        input.selectionEnd = input.selectionStart;
      }

      return;
    }

    if (typeof inputProps.onChange === 'function') {
      inputProps.onChange(e);
    }

    input.value = phoneMask(input.value);
  };

  return (
    <TextField
      {...otherProps}
      inputProps={{
        ...inputProps,
        onChange: handleChange,
        onPaste: handlePhonePaste,
        maxLength: 15,
        addonBefore: '+7',
        className: styles.field,
      }}
    />
  );
};

export default PhoneField;
